"use strict";
/**
 * Validation constants and configuration values for the Payslip Audit application.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_REGION = exports.RETENTION_DURATION_MONTHS = exports.MAX_RETAINED_REPORTS = exports.DELETION_RETRY_INTERVALS_MS = exports.DELETION_MAX_RETRIES = exports.AUTO_DELETE_TIMEOUT_MS = exports.SESSION_DURATION_MS = exports.EXTRACTION_TIMEOUT_MS = exports.DISCREPANCY_THRESHOLD_AUD = exports.SUPPORTED_EXTENSIONS = exports.SUPPORTED_FORMATS = exports.MAX_ROSTER_FILES = exports.MAX_PAGE_COUNT = exports.MAX_FILE_SIZE_BYTES = void 0;
/** Maximum file size for document uploads: 10 MB in bytes */
exports.MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
/** Maximum page count per uploaded document */
exports.MAX_PAGE_COUNT = 20;
/** Maximum number of roster files per audit (e.g., one per week of a fortnight) */
exports.MAX_ROSTER_FILES = 4;
/** Supported MIME types for document uploads */
exports.SUPPORTED_FORMATS = [
    'application/pdf',
    'image/png',
    'image/jpeg',
];
/** Supported file extensions (for client-side validation) */
exports.SUPPORTED_EXTENSIONS = ['.pdf', '.png', '.jpeg', '.jpg'];
/** Discrepancy threshold in AUD - differences at or below this are not flagged */
exports.DISCREPANCY_THRESHOLD_AUD = 0.01;
/** Extraction timeout in milliseconds */
exports.EXTRACTION_TIMEOUT_MS = 60_000; // 60 seconds
/** Maximum session duration in milliseconds (1 hour) */
exports.SESSION_DURATION_MS = 60 * 60 * 1000; // 1 hour
/** Auto-deletion timeout after report presentation in milliseconds */
exports.AUTO_DELETE_TIMEOUT_MS = 60_000; // 60 seconds
/** Deletion retry configuration */
exports.DELETION_MAX_RETRIES = 3;
exports.DELETION_RETRY_INTERVALS_MS = [5_000, 15_000, 30_000];
/** Maximum retained reports per user */
exports.MAX_RETAINED_REPORTS = 52;
/** Retention duration in months */
exports.RETENTION_DURATION_MONTHS = 24;
/** AWS region for all resources */
exports.AWS_REGION = 'ap-southeast-2';
//# sourceMappingURL=constants.js.map